export class MainDataBase {
    ObjectType?: string = 'Rodzaj obiektu';
    ID?: string = 'ID';
    WorkNumber?: string = 'Nr roboczy';
    District?: string = 'Gmina';
    Poviat?: string = 'Powiat';
    Voivodeship?: string = 'Województwo';
    Template?: string = 'Wzór';
};

export const mockUpData = () => {
    const defaultData: MainDataBase[] = [
        {
            ObjectType: 'POTZ',
            ID: '001234',
            WorkNumber: '001234-YTF',
            Voivodeship: 'zachodniopomorskie',
            Template: '2020',
            District: 'Czechowice-Dziedzice',
            Poviat: 'czarnkowsko-czcianecki'
        },
        {
            ObjectType: 'POTZ',
            ID: '001234',
            WorkNumber: '001234-YTF',
            Voivodeship: 'zachodniopomorskie',
            Template: '2020',
            District: 'Czechowice-Dziedzice',
            Poviat: 'czarnkowsko-czcianecki'
        },
        {
            ObjectType: 'KRO',
            ID: '001234',
            WorkNumber: '001234-YTF',
            Voivodeship: 'zachodniopomorskie',
            Template: '2020',
            District: 'Czechowice-Dziedzice',
            Poviat: 'czarnkowsko-czcianecki'
        },
        {
            ObjectType: 'POTZ',
            ID: '001234',
            WorkNumber: '001234-YTF',
            Voivodeship: 'zachodniopomorskie',
            Template: '2020',
            District: 'Czechowice-Dziedzice',
            Poviat: 'czarnkowsko-czcianecki'
        },
        {
            ObjectType: 'KRO',
            ID: '001234',
            WorkNumber: '001234-YTF',
            Voivodeship: 'zachodniopomorskie',
            Template: '2020',
            District: 'Czechowice-Dziedzice',
            Poviat: 'czarnkowsko-czcianecki'
        },
    ]
    return defaultData;
}